/**
 * The record a document was created with, for a field that mints its own entity when it opens.
 *
 * A host that creates a document already populated (ex. a sample-plan row opening Sample Creation for
 * one line item, material and sample type) writes the new entity's starting fields at the field's
 * `__Record` address. Minting the new record starts from those fields instead of replacing them, so
 * the open-time cascade shows them and the save writes them. Only a record with no identity counts:
 * one carrying a GUID or a database ID is a selection, and minting never adopts a selection.
 *
 * Used by both families' `_handleDefaultRecord` (MaterialsEntitySelector and MaterialsCascadePicker).
 *
 * @module _SeedRecord
 */

/**
 * @param {any} pRecord - what the document holds at the field's `__Record` address
 * @param {string} pEntity - the field's entity (ex. 'Sample')
 * @param {string} [pIdentityField] - the field's record identity, when it isn't GUID<Entity> or ID<Entity>
 * @return {Record<string, any>|null} a copy of the seed to start the new record from, or null
 */
function getUnsavedSeedRecord(pRecord, pEntity, pIdentityField)
{
	if (!pRecord || typeof pRecord !== 'object' || Array.isArray(pRecord) || Object.keys(pRecord).length < 1)
	{
		return null;
	}
	if (pRecord[`GUID${pEntity}`] || (Number(pRecord[`ID${pEntity}`]) > 0))
	{
		return null;
	}
	if (pIdentityField && pRecord[pIdentityField])
	{
		return null;
	}
	return JSON.parse(JSON.stringify(pRecord));
}

module.exports = { getUnsavedSeedRecord };
